import axios from 'axios';
import { ElMessage,ElMessageBox } from 'element-plus'
require("babel-polyfill");
import { url1} from './url';
import router from "../router";
import {setStorage,getStorage} from '@/utils/util'
import sysConfig from "@/config"
import {delCookie, getCookie, setCookie} from '@/utils/util'
var request = axios.create({
    timeout: sysConfig.TIMEOUT,
    // timeout:5000,
    withCredentials: true
});
function ajax(opt,method){
  var token= getStorage('logintoken')
  
 
  // var timestamp=new Date().getTime();
  var params;

  if(opt.params){
   
    
    //对传入的参数进行深拷贝，防止传入的参数对象被页面上其他逻辑改变，导致签名错误
    if (Object.prototype.toString.call(opt.params) != '[object FormData]') {
      // 不是formdata类型
      params = JSON.parse(JSON.stringify(opt.params));
    }else{//formdata类型
      params= opt.params
    }
    if(method=='GET') {
      params={
        ...params,
        // 't':timestamp
      }
    }
  }else{
    
    
    params={}
  }

  if(method == 'PUT' || method == 'DELETE') {
      var config={
          url: url1 + opt.url +'/' + params.id,//+'/',
          method: method,
          
      }
      if(!params.id){
          config={
          url: url1 + opt.url,
          method: method,
        
        }
      }

      method==="PUT"&&(config.params=params);
      return new Promise((resolve,reject)=>{
          request({
                url: config.url,
                method: method,
                // headers:{
                //     Authorization: 'JWT ' + token,
                // },
                data: params
              }).then(res=>{
                
                
              if(res.data.code==10001 || res.data.code==10002){
         
                  ElMessageBox.alert('登录信息失效,请重新登录！','登录失效',{
                      confirmButtonText:'确定',
                      type: 'warning',
                      callback: action => {
                          //跳转登录页   callback点击确定按钮后的回调函数
                          localStorage.clear();
                          sessionStorage.clear();
                          window.location.href="/"
                      }
                  })
              }else{
                  resolve(res.data)
              }
          }).catch(res=>{
              ElMessage.error("请求失败");
              reject(res)
          })
      })
  }else if(method == 'GET2'){
      var config2={
          url: url1 + opt.url +'/' + params.id, //url + opt.url + params.id+'/',
          method: 'GET',
        //   headers:{
        //       Authorization: 'JWT ' + token,
        //   }
      }
      if(!params.id){
          config2={
              url: url1 + opt.url,
              method: 'GET',
            //   headers:{
            //       Authorization: 'JWT ' + token,
            //   }
          }
      }
      return new Promise((resolve,reject)=>{
          request({
              url: config2.url,
              method: 'GET',
            //   headers:{
            //       Authorization: 'JWT ' + token,
            //   },
              data: params
          }).then(res=>{
        
              if(res.data.code==10001 || res.data.code==10002){
          
                  ElMessageBox.alert('登录信息失效,请重新登录！','登录失效',{
                      confirmButtonText:'确定',
                      type: 'warning',
                      callback: action => {
                          //跳转登录页   callback点击确定按钮后的回调函数
                          localStorage.clear();
                          sessionStorage.clear();
                          window.location.href="/"
                      }
                  }
                )
              }else{
                  resolve(res.data)
              }
          }).catch(error=>{
            ElMessage.error("请求失败");
            if(error.response)
              reject(error.response.data)
            else
              reject(error)
        })
      })
  }
  else {
      var config1={
          url: url1 + opt.url,
          method: method,
          // headers:{
          //     Authorization: 'JWT ' + token,
          // }
      }
    
      
      method==="GET"&&(config1.params=params);
      method==="POST"&&(config1.data=params);
      method==="PATCH"&&(config1.data=params);
     
      
      return new Promise((resolve,reject)=>{
          request(config1).then(res=>{
             
            
              
              if(res.data.code==10001 || res.data.code==10002){
                
                  
                  var login_message = '登录信息失效,请重新登录！'
                  if(res.data.msg){
                    if(res.data.msg.includes("用户名或密码错误"))
                      login_message = "用户名或密码错误"
                  }
                  ElMessageBox.alert(login_message,'登录失效',{
                      confirmButtonText:'确定',
                      type: 'warning',
                      callback: action => {
                          //跳转登录页   callback点击确定按钮后的回调函数
                          localStorage.clear();
                          sessionStorage.clear();
                          window.location.href="/"
                      }
                  })
              }else{
                //resolve(res.data)
                resolve(res)
              }
          }).catch(error=>{
              ElMessage.error("请求失败");
              if(error.response)
                reject(error.response.data)
              else
                reject(error)
          })
      })
  }
};


export function ajaxGet1 (opt) {
    return ajax(opt,"GET")
}
export function ajaxPut1 (opt) {
    return ajax(opt,"PUT")
}
export function ajaxDelete1 (opt) {
    return ajax(opt,"DELETE")
}
export function ajaxPost1 (opt) {
  return ajax(opt,"POST")
}
export function ajaxPatch1 (opt) {
  return ajax(opt,"PATCH")
}
// 单例详情获取get /api/test/12xxxxxxxx/
export function ajaxGetDetailByID1 (opt) {
    return ajax(opt,"GET2")
}




export function reqExpost (method, url, params) {
  // const timestamp = new Date().getTime().toString();
  let token = getStorage('logintoken')
  for (let key in params){
    if(params[key]==null || params[key] == 'undefined' ||  params[key]==''){
      delete params[key]
    }
  }
  const keys = Object.keys(params).sort(); let i;
  const length = keys.length;
  let key;
  let sortedString = '';
  for (i = 0; i < length; i++) {
    key = keys[i];
    sortedString += (key + '=' + params[key]);
  }
  return axios({
    method: method,
    url: url ,
    headers: {
      'Content-Type': 'application/json',
      // Authorization: 'JWT ' + token,
    },
    data: params,
    responseType: 'blob' // 表明返回服务器返回的数据类型
  }).then(res => res.data);
}



// 上传PDF
export function uploadPdf1(param) {

  var requestImg = axios.create({
    timeout: sysConfig.TIMEOUT,
    withCredentials: true
  });

  let formData = new FormData()
  formData.append('report_url', param.params.param.file)
  formData.append('fault_id', param.params.fault_id)

  return requestImg.put( url1 +param.url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: progressEvent => {
      let loadProgress = (progressEvent.loaded / progressEvent.total * 100)
      if(param.params.onProgress){
        param.params.onProgress({percent: loadProgress})
      }
    },
  }).then(res => res.data).catch(error => {
    ElMessage.error("上传报告失败");
    throw error; 
  });

}


// 上传月度PDF报告
export function uploadPdfMonth1(param) {

  var requestImg = axios.create({
    timeout: sysConfig.TIMEOUT,
    withCredentials: true
  });
  let formData = new FormData()
  formData.append('report_url', param.params.param.file)
  formData.append('device_name', param.params.device_name)
  formData.append('month', param.params.month)

  return requestImg.put( url1 + param.url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: progressEvent => {
      let loadProgress = (progressEvent.loaded / progressEvent.total * 100)
      if(param.params.onProgress){
        param.params.onProgress({percent: loadProgress})
      }
    },
  }).then(res => res.data).catch(error => {
    ElMessage.error("上传报告失败");
    throw error; 
  });

}

